import React from 'react';
import { Modal, Input, Form, Button } from 'antd';

import EstablecimientoResultList from './DetalleFormModal/EstablecimientoResultList';

const { Search } = Input;

class DetalleFormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    }

    handleSave = (id, e) => {
        if (e !== undefined)
            e.preventDefault();

        if (e === undefined || e.keyCode === 13)
            this.props.form.validateFields((errors, values) => {
                if (!errors) {
                    const form = {
                        id,
                        listaPrecioId: values.id,
                        precioUnitario: parseFloat(values.arrPrecioUnitario['LP' + id])
                    }
                    this.props.onSave(form, this.props.form);
                }
            });
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        getFieldDecorator('id', { initialValue: this.props.formValues.id });
        return (
            <Modal
                title={"Establecimientos"}
                visible={this.props.visible}
                onCancel={(properties) => {
                    if (!properties.target.className.toString().match('ant-modal-wrap') || properties.type === 'keydown')
                        this.handleCancel();
                }}
                style={{ top: 30 }}
                width="850px"
                footer={[
                    <Button key="1" onClick={this.handleCancel}>
                        Cancelar
                    </Button>
                ]}
            >
                <Form>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Form.Item label="">
                                {getFieldDecorator('nombre', {
                                    initialValue: this.props.formValues.nombre
                                })(
                                    <Search
                                        placeholder="Búsqueda Nombre"
                                        autoComplete="off"
                                        maxLength={100}
                                        loading={this.props.formValues.searchLoading}
                                        onSearch={value => this.props.onSearch(value)}
                                    />
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <EstablecimientoResultList
                                source={this.props.formValues.detalle}
                                onNew={this.props.onNew}
                                onEdit={this.props.onEdit}
                                onDeleteActive={this.props.onDeleteActive}
                            />
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}
export default Form.create()(DetalleFormModal)